import { render, staticRenderFns } from "./TournamentRanking.vue?vue&type=template&id=fc7de1a4&scoped=true&"
import script from "./TournamentRanking.vue?vue&type=script&lang=js&"
export * from "./TournamentRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7de1a4",
  null
  
)

export default component.exports